import { message } from 'antd'
import { Moment } from 'moment-timezone'
import { recommendedQuantitiesToHitDeliveryDate } from '@Builder/QuoteDetailPage/FilesTab/CostAndLeadTimePage/components/PartQLLTView/recommendedQuantityToReduceLeadTime'
import { ApolloQueryResult } from '@apollo/client'
import { QlltOption } from '@Builder/QuoteDetailPage/FilesTab/QuoteLevelLeadTime/__generated__/QlltOption'

import {
    PrimaryProcessConfigInput,
    SecondaryProcessConfigInput,
} from '~/__generated__/globalTypes'
import { types as GraphqlTypes } from '~/redux-modules/graphql'
import {
    getCoreQuoteDetailsData,
    getLegacyQuoteDetailsData,
} from '~/redux-modules/query-refactor/actions'
import { isCoreSuccessState } from '~/redux-modules/query-refactor/selector'
import {
    CostAndLeadTime_quote,
    CostAndLeadTime_quote_quoteModels_items_selectedQuoteModelRevision_processesDetails_primaryProcess_price_ExactPrice as costAndLeadTimePrimaryProcessExactPrice,
    CostAndLeadTime_quote_quoteModels_items_selectedQuoteModelRevision_processesDetails_totalPrice_ExactPrice as costAndLeadTimeTotalExactPrice,
    CostAndLeadTime_quote_quoteModels_items_selectedQuoteModelRevision as SelectedQMRType,
    CostAndLeadTime_quote_quoteModels_items_selectedQuoteModelRevision_processesDetails_postProcesses as PostProcessType,
} from '~/redux-modules/quote-qllt/__generated__/CostAndLeadTime'
import {
    GetBusinessAccountFeature,
    GetBusinessAccountFeature_getBusinessAccountFeature as BusinessAccountFeatureType,
} from '~/redux-modules/quote-qllt/__generated__/GetBusinessAccountFeature'
import { OptionType as QLLTOptionType } from '~/apps/consumer/pages/Quotes/Builder/QuoteDetailPage/FilesTab/QuoteLevelLeadTime/constants'
import { formatSecondaryProcesses } from '~/apps/consumer/pages/Quotes/Builder/QuoteDetailPage/FilesTab/CostAndLeadTimePage/logic'
import { getUserIdentity } from '../identity'
import { quoteLevelLeadTimesWithShippingOptionsQuery } from '~/apps/consumer/pages/Quotes/Builder/QuoteDetailPage/FilesTab/QuoteLevelLeadTime/query'
import logger from '~/lib/logger'
import { QlltData } from '~/redux-modules/quote-qllt/types'
import {
    RESET_LAST_ACTION_PERFORMED,
    SET_IS_EDIT_PDF_MODE,
    SET_QLLT_SELECTED_OPTION,
} from '~/redux-modules/quote-qllt/constants'
import { roundNearest5 } from '~/redux-modules/quote-qllt/logic'
import { RecommendedQuantitiesToHitDeliveryDate_recommendedQuantitiesToHitDeliveryDate as RecommendedQuantitiesToHitDeliveryDateType } from '~/apps/consumer/pages/Quotes/Builder/QuoteDetailPage/FilesTab/CostAndLeadTimePage/components/PartQLLTView/__generated__/RecommendedQuantitiesToHitDeliveryDate'
import {
    QuoteDetailsCheckoutDocument,
    UpdateProcessConfigsOnQmrsDocument,
    UpdateProcessConfigsOnQmrsMutation,
    UpdateProcessConfigsOnQmrsMutationVariables,
    DestroyQuoteModelRevisionTapOnHolesDocument,
} from '~/gql/graphql'

import {
    SET_COST_AND_LEAD_TIME,
    SET_COST_AND_LEAD_TIME_FAILURE,
    SET_COST_AND_LEAD_TIME_LOADING,
    SET_NEED_BY_DATE_FAILURE,
    SET_NEED_BY_DATE_LOADING,
    SET_QLLT_DATA,
    SET_QLLT_DATA_FAILURE,
    SET_QLLT_DATA_LOADING,
    GET_ALL_BATCH_POST_PROCESS_FAILURE,
    GET_ALL_BATCH_POST_PROCESS_QUERY_DATA,
    SET_ALL_BATCH_POST_PROCESS_LOADING,
    SET_PROCESS_CONFIG_TO_QMR,
    SET_PROCESS_DETAILS_LOADING,
    GET_PROCESS_DETAILS_FAILURE,
    UPDATE_PROCESS_CONFIG_DATA,
    SET_QLLT_CONFIGURE_OPTION,
    RESET_OPTIMIZATION,
    GET_QLLT_SLACK_THREAD_QUERY_FAILURE,
    GET_QLLT_SLACK_THREAD_QUERY_LOADING,
    GET_QLLT_SLACK_THREAD_QUERY_SUCCESS,
    CREATE_SLACK_THREAD_FAILURE,
    CREATE_SLACK_THREAD_LOADING,
    SET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME,
    GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_FAILURE,
    GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_LOADING,
    REMOVE_ALL_THREADS_LOADING,
    REMOVE_ALL_THREADS_FAILURE,
    BUSINESS_ACCOUNT_FEATURE_QUERY_FAILURE,
    BUSINESS_ACCOUNT_FEATURE_QUERY_LOADING,
    BUSINESS_ACCOUNT_FEATURE_QUERY_SUCCESS,
    SET_BUSINESS_ACCOUNT_FEATURE_FAILURE,
    SET_BUSINESS_ACCOUNT_FEATURE_LOADING,
    SET_LAST_ACTION_PERFORMED,
    SET_3D_MODE,
} from './constants'
import {
    createQlltSlackThread,
    updateNeedByDateMutation,
    updateBusinessAccountFeature,
    recordCltOptimizerView,
    recordCltOptimizationMutation,
    LogRequestAssistance,
    GenerateCltOptimizerReport,
} from './mutation'
import {
    qmrLeadTimeContributions,
    queryForGetAllBatchPostProcessIds,
    CostAndLeadTime,
    getQlltSlackThreadQuery,
    getBusinessAccountFeatureQuery,
    calculateQuoteModelRevisionPendingPricesBreakdownPercentages,
} from './queries'
import { isQueryDetailsQueryRefactorOn, costAndLeadTimeData } from './selectors'
import { ProcessConfig, ProcessStateData, StateData, StateType } from './types'
import { CostAndLeadTime as CostAndLeadTimeType } from './__generated__/CostAndLeadTime'
import { QmrLeadTimeContributions } from './__generated__/QmrLeadTimeContributions'
import { Query as batchProcessType } from './__generated__/Query'
import { CalculateQuoteModelRevisionPendingPricesBreakdownPercentages } from './__generated__/CalculateQuoteModelRevisionPendingPricesBreakdownPercentages'
import { GetQlltSlackThread } from './__generated__/GetQlltSlackThread'
import { RecordCltOptimizerView } from './__generated__/RecordCltOptimizerView'
import { GenerateCltOptimizerReport as GenerateCltOptimizerReportType } from './__generated__/GenerateCltOptimizerReport'
import { LogRequestAssistance as LogRequestAssistanceType } from './__generated__/LogRequestAssistance'
import { SetBusinessAccountFeature } from './__generated__/SetBusinessAccountFeature'
import { SendQlltOptimisationNotification } from './__generated__/SendQlltOptimisationNotification'
import { SetNeedByDate } from './__generated__/SetNeedByDate'
import { RecordCltOptimization } from './__generated__/RecordCltOptimization'

export const setIsEditPdfMode = (flag: boolean) => ({
    type: SET_IS_EDIT_PDF_MODE,
    payload: flag,
})
export const setNeedByDateLoading = (flag: boolean) => ({
    type: SET_NEED_BY_DATE_LOADING,
    payload: flag,
})

export const setNeedByDateFailure = (error: string) => ({
    type: SET_NEED_BY_DATE_FAILURE,
    payload: error,
})

export const setAllBatchPostProcessIdsQueryLoading = (flag: boolean) => ({
    type: SET_ALL_BATCH_POST_PROCESS_LOADING,
    payload: flag,
})

export const getAllBatchPostProcessIdsQueryFailure = (error: string) => ({
    type: GET_ALL_BATCH_POST_PROCESS_FAILURE,
    payload: error,
})

export const getAllBatchPostProcessIdsQueryData = (data: Array<string>) => ({
    type: GET_ALL_BATCH_POST_PROCESS_QUERY_DATA,
    payload: data,
})

export const setLastActionPerformedData = (
    operation: string,
    description: string,
    affectedQmrIds: Array<string>,
) => ({
    type: SET_LAST_ACTION_PERFORMED,
    payload: { operation, description, affectedQmrIds },
})
export const resetLastActionPerformedData = () => ({
    type: RESET_LAST_ACTION_PERFORMED,
})

export const setTargetDeliveryDate = (payload: {
    needByDate: Moment | null
    quoteId: string
}) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const state = getState()
            const isQueryDetailsQueryRefactorFlag =
                isQueryDetailsQueryRefactorOn(state)

            dispatch(setNeedByDateLoading(true))
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient

            await apolloClient.mutate<SetNeedByDate>({
                mutation: updateNeedByDateMutation,
                variables: {
                    quoteId: payload.quoteId,
                    needByDate: payload.needByDate,
                },
                refetchQueries: !isQueryDetailsQueryRefactorFlag
                    ? [
                          {
                              query: QuoteDetailsCheckoutDocument,
                              variables: { id: payload.quoteId },
                          },
                      ]
                    : [],
            })

            message.success('Target delivery date updated!')
            if (isQueryDetailsQueryRefactorFlag) {
                dispatch(getCoreQuoteDetailsData(payload.quoteId))
            } else {
                dispatch(getLegacyQuoteDetailsData(payload.quoteId))
            }
            dispatch(setNeedByDateLoading(false))
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            message.error(errorMessage)
            dispatch(setNeedByDateFailure(errorMessage))
        }
    }
}

export const setQlltDataLoading = (isLoading: boolean) => ({
    type: SET_QLLT_DATA_LOADING,
    payload: isLoading,
})
export const setQlltDataFailure = (error: string) => ({
    type: SET_QLLT_DATA_FAILURE,
    payload: error,
})
export const setQlltData = (data: StateData) => ({
    type: SET_QLLT_DATA,
    payload: data,
})

export const recordCltOptimization = (payload: {
    qmrId: string
    initialQlltData: QlltData
    finalQlltData: QlltData
}) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for getState
    return async (dispatch, getState) => {
        try {
            const { qmrId, initialQlltData, finalQlltData } = payload
            const state = getState()

            if (!state.quoteQllt.lastActivityPerformed) {
                return
            }
            const { operation, description } =
                state.quoteQllt.lastActivityPerformed

            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient

            await apolloClient.mutate<RecordCltOptimization>({
                mutation: recordCltOptimizationMutation,
                variables: {
                    quoteModelRevisionId: qmrId,
                    operation: operation,
                    description: description,
                    initialCostCents: initialQlltData.totalPriceInCents,
                    initialTimeDays: initialQlltData.totalTimeInDays,
                    initialQuantity: initialQlltData.quantity,
                    finalCostCents: finalQlltData.totalPriceInCents,
                    finalTimeDays: finalQlltData.totalTimeInDays,
                    finalQuantity: finalQlltData.quantity,
                },
            })
            dispatch(resetLastActionPerformedData())
        } catch (error) {
            logger.exception(error)
        }
    }
}
const getQmrLeadTimeContributions = (
    quoteModelRevisionId: string,
    client: GraphqlTypes.ApolloClientType,
): Promise<ApolloQueryResult<QmrLeadTimeContributions>> => {
    return client.query({
        query: qmrLeadTimeContributions,
        variables: {
            quoteModelRevisionId,
        },
        fetchPolicy: 'network-only',
    })
}

const getCalculateQuoteModelRevisionPendingPricesBreakdownPercentages = (
    quoteModelRevisionId: string,
    client: GraphqlTypes.ApolloClientType,
): Promise<
    ApolloQueryResult<CalculateQuoteModelRevisionPendingPricesBreakdownPercentages>
> => {
    return client.query({
        query: calculateQuoteModelRevisionPendingPricesBreakdownPercentages,
        variables: {
            quoteModelRevisionId,
        },
        fetchPolicy: 'network-only',
    })
}
const getLeadTimeAndPrices = async (
    quoteModelRevisionId: string,
    client: GraphqlTypes.ApolloClientType,
) => {
    const [leadTimeRes, qmrPendingPricesRes] = await Promise.all([
        getQmrLeadTimeContributions(quoteModelRevisionId, client),
        getCalculateQuoteModelRevisionPendingPricesBreakdownPercentages(
            quoteModelRevisionId,
            client,
        ),
    ])

    return {
        leadTimeData:
            leadTimeRes.data.qmrLeadTimeContributions
                ?.fastestDomesticLeadTimeBreakdown,
        pricingData:
            qmrPendingPricesRes.data
                .calculateQuoteModelRevisionPendingPricesBreakdownPercentages?.[0],
    }
}

export const getQuoteQlltData = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setQlltDataLoading(true))

            const state = getState()
            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient
            const quote = costAndLeadTimeData(state)

            if (!quote) {
                throw new Error('costAndLeadTimeData not yet settled.')
            }

            const quoteModels = quote.quoteModels.items

            const results = await Promise.all(
                quoteModels.map(model =>
                    getLeadTimeAndPrices(
                        model.selectedQuoteModelRevision.id,
                        apolloClient,
                    ),
                ),
            )

            let data: StateData = {}

            quoteModels.forEach((model, index) => {
                const { leadTimeData, pricingData } = results[index]
                const { selectedQuoteModelRevision } = model
                const quantity =
                    selectedQuoteModelRevision.modelConfiguration?.quantity || 0
                const postProcesses =
                    selectedQuoteModelRevision.processesDetails?.postProcesses?.map(
                        p => ({
                            totalTimeInDays: p.postProcessLeadTimeInDays || 0,
                            totalPriceInCents:
                                (p.unitPriceInCents || 0) * quantity,
                            title: p.postProcess.name,
                            postProcessInfo: p,
                        }),
                    )

                const postProcessTotalDays =
                    postProcesses?.reduce((total, process) => {
                        return total + process.totalTimeInDays
                    }, 0) || 0

                const primaryProcessPrice = selectedQuoteModelRevision
                    .processesDetails?.primaryProcess
                    ?.price as costAndLeadTimePrimaryProcessExactPrice

                const totalProductionLeadTimeInDays =
                    selectedQuoteModelRevision.modelConfiguration
                        ?.productionLeadTime?.productionDays || 0

                const machining = {
                    totalTimeInDays:
                        totalProductionLeadTimeInDays - postProcessTotalDays,
                    totalPriceInCents: primaryProcessPrice?.priceInCents
                        ? primaryProcessPrice.priceInCents
                        : 0,

                    tightTolerance: {
                        totalTimeInDays:
                            leadTimeData?.additionalDays?.tightTolerance || 0,
                        costInPercentage: roundNearest5(
                            pricingData?.toleranceCost || 0,
                        ),
                    },

                    threads: {
                        totalTimeInDays:
                            leadTimeData?.additionalDays?.smallTaps || 0,
                        costInPercentage: roundNearest5(
                            pricingData?.threadCost || 0,
                        ),
                    },
                }

                const totalPrice = selectedQuoteModelRevision?.processesDetails
                    ?.totalPrice as costAndLeadTimeTotalExactPrice

                data = {
                    ...data,
                    [selectedQuoteModelRevision.id]: {
                        fileName: selectedQuoteModelRevision.fileName,
                        thumbnailUri:
                            selectedQuoteModelRevision.partRevision
                                .thumbnailUri,
                        version: selectedQuoteModelRevision.version,
                        quantity:
                            selectedQuoteModelRevision.modelConfiguration
                                ?.quantity,
                        postProcesses,
                        machining,
                        totalTimeInDays: totalProductionLeadTimeInDays,
                        totalPriceInCents: totalPrice
                            ? totalPrice.priceInCents
                            : 0,
                    },
                }
            })
            // Activity Log

            const lastActivityPerformed = state.quoteQllt.lastActivityPerformed

            if (lastActivityPerformed) {
                lastActivityPerformed.affectedQmrIds.forEach(
                    (qmrId: string) => {
                        const previousData = state.quoteQllt.data[qmrId]

                        if (previousData) {
                            dispatch(
                                recordCltOptimization({
                                    qmrId,
                                    initialQlltData: previousData,
                                    finalQlltData: data[qmrId],
                                }),
                            )
                        }
                    },
                )
            }
            if (
                !state.quoteQllt.data ||
                Object.keys(state.quoteQllt.data).length === 0
            ) {
                // Sorting in descending order and assign index
                Object.keys(data)
                    .sort(
                        (key1, key2) =>
                            data[key2].totalTimeInDays -
                            data[key1].totalTimeInDays,
                    )
                    .forEach((qmrId, index) => {
                        data[qmrId].index = index
                    })
            } else {
                // Assign index from previous data
                Object.keys(data).forEach(key => {
                    if (state.quoteQllt.data[key]) {
                        data[key].index = state.quoteQllt.data[key].index
                    }
                })
            }

            dispatch(setQlltData(data))
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            dispatch(setQlltDataFailure(error.message))
        }
    }
}

export const setCostAndLeadTimeDataLoading = (isLoading: boolean) => ({
    type: SET_COST_AND_LEAD_TIME_LOADING,
    payload: isLoading,
})
export const setCostAndLeadTimeDataFailure = (error: string) => ({
    type: SET_COST_AND_LEAD_TIME_FAILURE,
    payload: error,
})
export const setCostAndLeadTimeData = (data: CostAndLeadTime_quote | null) => ({
    type: SET_COST_AND_LEAD_TIME,
    payload: data,
})

export const getCostAndLeadTimeData = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setCostAndLeadTimeDataLoading(true))
            const state = getState()
            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient
            const isQueryDetailsQueryRefactorFlag =
                isQueryDetailsQueryRefactorOn(state)

            let quoteId: string

            if (isQueryDetailsQueryRefactorFlag) {
                quoteId = isCoreSuccessState(state.queryRefactor)
                    ? state.queryRefactor.coreQuoteDetails?.coreQuoteDetailsData
                          ?.id
                    : null
            } else {
                quoteId = state.dfmLayers.quote.id
            }
            if (!quoteId) {
                throw new Error('Quote not yet settled.')
            }

            const { data } = await apolloClient.query<CostAndLeadTimeType>({
                query: CostAndLeadTime,
                variables: {
                    quoteId,
                },
                fetchPolicy: 'network-only',
            })

            dispatch(setCostAndLeadTimeData(data.quote))

            dispatch(getQuoteQlltData())
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            dispatch(setCostAndLeadTimeDataFailure(error.message))
        }
    }
}

export const getAllBatchPostProcessIdsData = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setAllBatchPostProcessIdsQueryLoading(true))

            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.query<batchProcessType>({
                query: queryForGetAllBatchPostProcessIds,
                variables: {},
                fetchPolicy: 'network-only',
            })

            const { data } = res

            dispatch(
                getAllBatchPostProcessIdsQueryData(
                    data.getAllBatchPostProcessIds,
                ),
            )
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            message.error(errorMessage)
            dispatch(getAllBatchPostProcessIdsQueryFailure(errorMessage))
        }
    }
}
export const setQlltConfigureOption = (payload: QLLTOptionType) => ({
    type: SET_QLLT_CONFIGURE_OPTION,
    payload,
})

export const setProcessConfigToQmr = (selectedQmr: SelectedQMRType) => {
    return {
        type: SET_PROCESS_CONFIG_TO_QMR,
        payload: {
            [selectedQmr.id]: {
                secondaryProcess: formatSecondaryProcesses(
                    selectedQmr.processesDetails?.postProcesses || [],
                ),

                removedSecondaryProcess: [],
            },
        },
    }
}

export const setProcessDetailsLoading = (isLoading: boolean) => ({
    type: SET_PROCESS_DETAILS_LOADING,
    payload: isLoading,
})
export const setProcessDetailsFailure = (error: string) => ({
    type: GET_PROCESS_DETAILS_FAILURE,
    payload: error,
})

export const updateProcessConfigData = (data: ProcessStateData) => ({
    type: UPDATE_PROCESS_CONFIG_DATA,
    payload: data,
})

const getPrimaryProcessConfig = (state: StateType, qmrId: string) => {
    const quote = state.costAndLeadTimeData
    const selectedQmr = quote?.quoteModels?.items?.find(
        item => item.selectedQuoteModelRevision.id === qmrId,
    )?.selectedQuoteModelRevision
    const {
        colorCode,
        materialGrade,
        textureCode,
        material,
        quantity,
        productionLeadTime,
    } = selectedQmr?.modelConfiguration || {}
    const processId = selectedQmr?.processesDetails?.primaryProcess?.process.id
    const materialId = material?.id
    const priorityId = productionLeadTime?.priorityId
    const primaryProcessConfig = {
        colorCode,
        materialGrade,
        materialId,
        processId,
        textureCode,
        quantity,
        priorityId,
    }

    return primaryProcessConfig
}

const removePostProcess = async (
    qmrId: string,
    postProcessId: string,
    selectedProcessConfig: ProcessConfig,
    apolloClient: GraphqlTypes.ApolloClientType,
    state: StateType,
) => {
    const removingPostProcess = selectedProcessConfig.secondaryProcess.find(
        process => process.processId === postProcessId,
    )

    const primaryProcessConfig = getPrimaryProcessConfig(state, qmrId)

    if (!removingPostProcess) {
        return {
            ...selectedProcessConfig,
        }
    }
    const removedData = [
        ...selectedProcessConfig.removedSecondaryProcess,
        removingPostProcess,
    ]

    const updatedSecondaryProcess = selectedProcessConfig.secondaryProcess
        .filter(
            process =>
                !removedData.find(
                    removedProcess =>
                        removedProcess.processId === process.processId,
                ),
        )
        .map(({ info, ...rest }) => ({ ...rest }))

    await apolloClient.mutate<
        UpdateProcessConfigsOnQmrsMutation,
        UpdateProcessConfigsOnQmrsMutationVariables
    >({
        mutation: UpdateProcessConfigsOnQmrsDocument,
        variables: {
            ids: qmrId,
            primaryProcessConfig: primaryProcessConfig,
            secondaryProcessConfigs: updatedSecondaryProcess,
        } as any, // todo fix proper types after PR https://github.com/fictiv/fictiv-js/pull/7007 merged
        refetchQueries: ['QuoteLevelLeadTimesWithShippingOptions'],
    })

    return {
        [qmrId]: {
            ...selectedProcessConfig,
            removedSecondaryProcess: removedData,
        },
    }
}

export const refetchQuoteLevelLeadTimesAndPricesQuery = (quoteId: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        const state = getState()
        const apolloClient: GraphqlTypes.ApolloClientType =
            state.graphql.apolloClient

        await apolloClient.query({
            query: quoteLevelLeadTimesWithShippingOptionsQuery,
            variables: {
                quoteId,
            },
            fetchPolicy: 'network-only',
        })
    }
}

export const removeSecondaryProcessFromQmr = (payload: {
    qmrIds: string[]
    postProcess: PostProcessType
}) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setProcessDetailsLoading(true))
            const state = getState()
            const isQueryDetailsQueryRefactorFlag =
                isQueryDetailsQueryRefactorOn(state)

            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient
            const processConfigs = state.quoteQllt.processConfig
            const updatedResults = await Promise.all(
                payload.qmrIds.map(id =>
                    removePostProcess(
                        id,
                        payload.postProcess.postProcess.id,
                        processConfigs[id],
                        apolloClient,
                        state.quoteQllt,
                    ),
                ),
            )

            if (isQueryDetailsQueryRefactorFlag) {
                const quoteId = isCoreSuccessState(state.queryRefactor)
                    ? state.queryRefactor.coreQuoteDetails?.coreQuoteDetailsData
                          ?.id
                    : null

                dispatch(getCoreQuoteDetailsData(quoteId))
            } else {
                dispatch(getLegacyQuoteDetailsData(state.dfmLayers.quote.id))
            }

            let data = {
                ...state.quoteQllt.processConfig,
            }

            updatedResults.forEach(result => {
                data = {
                    ...data,
                    ...result,
                }
            })

            dispatch(updateProcessConfigData(data))
            dispatch(getCostAndLeadTimeData())
            dispatch(
                setLastActionPerformedData(
                    'remove',
                    payload.postProcess.postProcess.name,
                    payload.qmrIds,
                ),
            )
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            message.error(errorMessage)
            dispatch(setProcessDetailsFailure(errorMessage))
        }
    }
}
const undoPostProcess = async (
    qmrId: string,
    postProcessId: string,
    selectedProcessConfig: ProcessConfig,
    apolloClient: GraphqlTypes.ApolloClientType,
    state: StateType,
) => {
    const primaryProcessConfig = getPrimaryProcessConfig(state, qmrId)

    const updatedRemovedData =
        selectedProcessConfig.removedSecondaryProcess.filter(
            rsp => rsp.processId !== postProcessId,
        )

    const updatedSecondaryProcess = selectedProcessConfig.secondaryProcess
        .filter(
            process =>
                !updatedRemovedData.find(
                    removedProcess =>
                        removedProcess.processId === process.processId,
                ),
        )
        .map(({ info, ...rest }) => ({ ...rest }))

    await apolloClient.mutate<
        UpdateProcessConfigsOnQmrsMutation,
        UpdateProcessConfigsOnQmrsMutationVariables
    >({
        mutation: UpdateProcessConfigsOnQmrsDocument,
        variables: {
            ids: qmrId,
            primaryProcessConfig: primaryProcessConfig,
            secondaryProcessConfigs: updatedSecondaryProcess,
        } as any, // todo fix proper types after PR https://github.com/fictiv/fictiv-js/pull/7007 merged
        refetchQueries: ['QuoteLevelLeadTimesWithShippingOptions'],
    })

    return {
        [qmrId]: {
            ...selectedProcessConfig,
            removedSecondaryProcess: updatedRemovedData,
        },
    }
}

export const undoRemovedSecondaryProcessFromQmr = (payload: {
    qmrIds: string[]
    postProcess: PostProcessType
}) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setProcessDetailsLoading(true))
            const state = getState()

            const isQueryDetailsQueryRefactorFlag =
                isQueryDetailsQueryRefactorOn(state)
            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient

            const processConfigs = state.quoteQllt.processConfig

            const updatedResults = await Promise.all(
                payload.qmrIds.map(id =>
                    undoPostProcess(
                        id,
                        payload.postProcess.postProcess.id,
                        processConfigs[id],
                        apolloClient,
                        state.quoteQllt,
                    ),
                ),
            )

            dispatch(
                setLastActionPerformedData(
                    'undo',
                    payload.postProcess.postProcess.name,
                    payload.qmrIds,
                ),
            )

            let quoteId: string

            if (isQueryDetailsQueryRefactorFlag) {
                quoteId = isCoreSuccessState(state.queryRefactor)
                    ? state.queryRefactor.coreQuoteDetails?.coreQuoteDetailsData
                          ?.id
                    : null

                dispatch(getCoreQuoteDetailsData(quoteId))
            } else {
                quoteId = state.dfmLayers.quote.id
                dispatch(getLegacyQuoteDetailsData(state.dfmLayers.quote.id))
            }

            dispatch(refetchQuoteLevelLeadTimesAndPricesQuery(quoteId))
            let data = {
                ...state.quoteQllt.processConfig,
            }

            updatedResults.forEach(result => {
                data = {
                    ...data,
                    ...result,
                }
            })

            dispatch(updateProcessConfigData(data))
            dispatch(getCostAndLeadTimeData())
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            message.error(errorMessage)
            dispatch(setProcessDetailsFailure(errorMessage))
        }
    }
}

export const resetOptimization = () => ({
    type: RESET_OPTIMIZATION,
})

export const setQlltSlackThreadLoading = (isLoading: boolean) => ({
    type: GET_QLLT_SLACK_THREAD_QUERY_LOADING,
    payload: isLoading,
})
export const setQlltSlackThreadFailure = (error: string) => ({
    type: GET_QLLT_SLACK_THREAD_QUERY_FAILURE,
    payload: error,
})
export const setQlltSlackThreadSuccess = (url: string | null) => ({
    type: GET_QLLT_SLACK_THREAD_QUERY_SUCCESS,
    payload: url,
})
export const getQlltSlackThreadData = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setQlltSlackThreadLoading(true))
            const state = getState()
            const quoteId = state.quoteQllt.costAndLeadTimeData?.id

            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient
            const res = await apolloClient.query<GetQlltSlackThread>({
                query: getQlltSlackThreadQuery,
                variables: { quoteId },
                fetchPolicy: 'network-only',
            })

            const { data } = res

            dispatch(
                setQlltSlackThreadSuccess(data.getQlltSlackThread?.url || null),
            )
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            message.error(errorMessage)
            dispatch(setQlltSlackThreadFailure(errorMessage))
        }
    }
}
export const setCreateSlackThreadLoading = (flag: boolean) => ({
    type: CREATE_SLACK_THREAD_LOADING,
    payload: flag,
})

export const setCreateSlackThreadFailure = (error: string) => ({
    type: CREATE_SLACK_THREAD_FAILURE,
    payload: error,
})
export const setCreateSlackThread = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const state = getState()

            dispatch(setCreateSlackThreadLoading(true))
            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient

            const quoteId = state.quoteQllt.costAndLeadTimeData?.id

            const { id: userId } = getUserIdentity(state)

            const res =
                await apolloClient.mutate<SendQlltOptimisationNotification>({
                    mutation: createQlltSlackThread,
                    variables: {
                        quoteId,
                        userId,
                    },
                })

            const { data } = res

            dispatch(setCreateSlackThreadLoading(false))

            dispatch(
                setQlltSlackThreadSuccess(
                    data?.sendQlltOptimisationNotification?.url || null,
                ),
            )
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            dispatch(setCreateSlackThreadFailure(errorMessage))
        }
    }
}

export const updateQuantityForQMR = (qmrId: string, newQuantity: number) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        dispatch(setProcessDetailsLoading(true))
        const state = getState()
        const apolloClient: GraphqlTypes.ApolloClientType =
            state.graphql.apolloClient
        const processConfig: ProcessConfig =
            state.quoteQllt.processConfig[qmrId]
        const primaryProcessConfig = getPrimaryProcessConfig(
            state?.quoteQllt,
            qmrId,
        )

        const updatedPrimaryProcessConfig: PrimaryProcessConfigInput = {
            ...primaryProcessConfig,
            quantity: newQuantity,
        }

        const secondaryProcessConfigs: SecondaryProcessConfigInput[] =
            processConfig.secondaryProcess
                .filter(
                    process =>
                        !processConfig.removedSecondaryProcess.find(
                            removedProcess =>
                                removedProcess.processId === process.processId,
                        ),
                )
                .map(({ info, ...rest }) => ({
                    ...rest,
                }))

        await apolloClient.mutate<
            UpdateProcessConfigsOnQmrsMutation,
            UpdateProcessConfigsOnQmrsMutationVariables
        >({
            mutation: UpdateProcessConfigsOnQmrsDocument,
            variables: {
                ids: qmrId,
                primaryProcessConfig: updatedPrimaryProcessConfig,
                removeManuallyQuotedSecondaryProcesses: false,
                secondaryProcessConfigs,
            } as any, // todo fix proper types after PR https://github.com/fictiv/fictiv-js/pull/7007 merged

            refetchQueries: ['QuoteLevelLeadTimesWithShippingOptions'],
        })

        dispatch(setLastActionPerformedData('update', 'quantity', [qmrId]))

        const isQueryDetailsQueryRefactorFlag =
            isQueryDetailsQueryRefactorOn(state)

        let quoteId: string

        if (isQueryDetailsQueryRefactorFlag) {
            if (!isCoreSuccessState(state.queryRefactor)) {
                return null
            } else {
                quoteId =
                    state.queryRefactor.coreQuoteDetails.coreQuoteDetailsData.id
                dispatch(getCoreQuoteDetailsData(quoteId))
            }
        } else {
            quoteId = state.dfmLayers.quote.id
            dispatch(getLegacyQuoteDetailsData(state.dfmLayers.quote.id))
        }

        dispatch(refetchQuoteLevelLeadTimesAndPricesQuery(quoteId))
        dispatch(getCostAndLeadTimeData())

        const newProcessConfig = {
            ...state.quoteQllt.processConfig,
            [qmrId]: {
                ...processConfig,
                primaryProcessConfig,
            },
        }

        dispatch(updateProcessConfigData(newProcessConfig))
    }
}

export const setRecommendedQuantity = (
    data: RecommendedQuantitiesToHitDeliveryDateType[],
) => ({
    type: SET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME,
    payload: data,
})

export const getRecommendedQuantityLoading = (isLoading: boolean) => ({
    type: GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_LOADING,
    payload: isLoading,
})

export const getRecommendedQuantityFailure = (error: string) => ({
    type: GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_FAILURE,
    payload: error,
})

export const getRecommendedQuantity = (
    quoteId: any,
    currentEstimatedDeliveryDate: any,
    desiredDeliveryDate: any,
) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const state = getState()

            dispatch(getRecommendedQuantityLoading(true))
            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient

            const res = await apolloClient.query({
                query: recommendedQuantitiesToHitDeliveryDate,
                variables: {
                    quoteId: quoteId,
                    currentEstimatedDeliveryDate: currentEstimatedDeliveryDate,
                    desiredDeliveryDate: desiredDeliveryDate,
                },
                fetchPolicy: 'network-only',
            })

            const { data } = res

            dispatch(
                setRecommendedQuantity(
                    data.recommendedQuantitiesToHitDeliveryDate || null,
                ),
            )
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            dispatch(getRecommendedQuantityFailure(errorMessage))
        }
    }
}
export const setRemoveAllThreadsLoading = (flag: boolean) => ({
    type: REMOVE_ALL_THREADS_LOADING,
    payload: flag,
})

export const setRemoveAllThreadsFailure = (error: string) => ({
    type: REMOVE_ALL_THREADS_FAILURE,
    payload: error,
})

export const removeAllThreadsData = (payload: {
    qmrId: string
    holesList: Array<string>
}) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const state = getState()

            const isQueryDetailsQueryRefactorFlag =
                isQueryDetailsQueryRefactorOn(state)

            dispatch(setRemoveAllThreadsLoading(true))
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient

            await apolloClient.mutate({
                mutation: DestroyQuoteModelRevisionTapOnHolesDocument,
                variables: {
                    quoteModelRevisionId: payload.qmrId,
                    holesList: payload.holesList,
                },

                refetchQueries: ['QuoteLevelLeadTimesWithShippingOptions'],
            })
            message.success('Threads Removed Successfully')

            dispatch(
                setLastActionPerformedData('remove', 'threads', [
                    payload.qmrId,
                ]),
            )

            if (isQueryDetailsQueryRefactorFlag) {
                const quoteId = isCoreSuccessState(state.queryRefactor)
                    ? state.queryRefactor.coreQuoteDetails?.coreQuoteDetailsData
                          ?.id
                    : null

                dispatch(getCoreQuoteDetailsData(quoteId))
            } else {
                dispatch(getLegacyQuoteDetailsData(state.dfmLayers.quote.id))
            }

            dispatch(getCostAndLeadTimeData())
            dispatch(setRemoveAllThreadsLoading(false))
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            message.error(errorMessage)
            dispatch(setRemoveAllThreadsFailure(errorMessage))
        }
    }
}

export const setBusinessAccountFeatureLoading = (isLoading: boolean) => ({
    type: BUSINESS_ACCOUNT_FEATURE_QUERY_LOADING,
    payload: isLoading,
})
export const setBusinessAccountFeatureFailure = (error: string) => ({
    type: BUSINESS_ACCOUNT_FEATURE_QUERY_FAILURE,
    payload: error,
})
export const setBusinessAccountFeatureSuccess = (
    data: BusinessAccountFeatureType | null,
) => ({
    type: BUSINESS_ACCOUNT_FEATURE_QUERY_SUCCESS,
    payload: data,
})
export const getBusinessAccountFeature = (businessAccountId: string) => {
    const FEATURE_NAME = 'clt_optimizer'

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setBusinessAccountFeatureLoading(true))
            const state = getState()

            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient
            const res = await apolloClient.query<GetBusinessAccountFeature>({
                query: getBusinessAccountFeatureQuery,
                variables: {
                    businessAccountId,
                    featureName: FEATURE_NAME,
                },
                fetchPolicy: 'network-only',
            })

            const { data } = res

            dispatch(
                setBusinessAccountFeatureSuccess(
                    data.getBusinessAccountFeature || null,
                ),
            )
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            dispatch(setBusinessAccountFeatureFailure(errorMessage))
        }
    }
}

export const setCLTBusinessAccountFeatureLoading = (isLoading: boolean) => ({
    type: SET_BUSINESS_ACCOUNT_FEATURE_LOADING,
    payload: isLoading,
})
export const setCLTBusinessAccountFeatureFailure = (error: string) => ({
    type: SET_BUSINESS_ACCOUNT_FEATURE_FAILURE,
    payload: error,
})

export const setCLTBusinessAccountFeature = (payload: {
    businessAccountId: string
    isEnabled: boolean
    featureId: string
}) => {
    const FEATURE_NAME = 'clt_optimizer'

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const state = getState()

            dispatch(setCLTBusinessAccountFeatureLoading(true))
            const apolloClient: GraphqlTypes.ApolloClientType =
                state.graphql.apolloClient

            await apolloClient.mutate<SetBusinessAccountFeature>({
                mutation: updateBusinessAccountFeature,
                variables: {
                    businessAccountId: payload.businessAccountId,
                    featureName: FEATURE_NAME,
                    isEnabled: payload.isEnabled,
                },
            })
            dispatch(getBusinessAccountFeature(payload.businessAccountId))
            dispatch(setCLTBusinessAccountFeatureLoading(false))
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            dispatch(setCLTBusinessAccountFeatureFailure(errorMessage))
        }
    }
}
export const updateQuoteActivityLog = (quoteId: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient

            await apolloClient.mutate<RecordCltOptimizerView>({
                mutation: recordCltOptimizerView,
                variables: {
                    quoteId: quoteId,
                },
            })
        } catch (error) {
            logger.exception(error)
        }
    }
}

export const getAssistanceActivityLog = (quoteId: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient

            await apolloClient.mutate<LogRequestAssistanceType>({
                mutation: LogRequestAssistance,
                variables: {
                    quoteId: quoteId,
                },
            })
        } catch (error) {
            logger.exception(error)
        }
    }
}

export const logCLTOptimizerReport = (quoteId: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient

            await apolloClient.mutate<GenerateCltOptimizerReportType>({
                mutation: GenerateCltOptimizerReport,
                variables: {
                    quoteId: quoteId,
                },
            })
        } catch (error) {
            logger.exception(error)
        }

        return {
            type: 'any',
        }
    }
}

export const set3DMode = (mode: boolean) => ({
    type: SET_3D_MODE,
    payload: mode,
})

export type SelectedQlltOption =
    | (Omit<QlltOption, '__typename'> & {
          name: string
      })
    | null

export const setQlltSelectedOption = (qlltOption: SelectedQlltOption) => ({
    type: SET_QLLT_SELECTED_OPTION,
    payload: qlltOption,
})
